import AreaService from "./area";
import AttributeService from "./attribute";
import AuthService from "./auth";
import BannerService from "./banner";
import CategoryService from "./categories";
import ChronicDiseasesService from "./chronic-diseases";
import CityService from "./city";
import ClientService from "./client";
import CommonQuestionservice from "./common-question";
import ComplaintService from "./complaint";
import DeliveryWorkersService from "./delivery-worker";
import DiscountCodeService from "./discount-code";
import DoctorService from "./doctor";
import GeneralNotificationService from "./general-notification";
import GeneralSettingervice from "./general-setting";
import HomePageListService from "./home-page-list";
import { httpclient } from "./http-client";
import Investorsservice from "./investor";
import MedicalSspecialtiesService from "./medical-specialties";
import NotificationService from "./notifications";
import OrderService from "./order";
import OrderNoteService from "./order-note";
import ParamService from "./param";
import PaymentDeliveryWorkersservice from "./payment-delivery-worker";
import PaymentPointService from "./payment-point";
import PointService from "./point";
import PolicyTermService from "./policy-term";
import PrizeService from "./prize";
import ProductService from "./product";
import ProductStoreService from "./product-store";
import RoleService from "./role";
import SliceService from "./slice";
import StatisticsService from "./statistics";
import StoreService from "./stroe";
import TagsService from "./tag";
import UnitPartitionService from "./unit-partition";

import DriverTrackingService from "./tracking-driver";
import TrademarkService from "./trademark";
import UnitsService from "./unit";
import UserService from "./user";
import MediaService from "./media";
import repotservice from "./report";
import RewardService from "./reward";
import StoreJoinRequestService from "./stroe-join-request";
import TrademarkManagerService from "./trademark-manager";
import TrademarkStatisticsService from "./trademark-statistics";
import BannerCategoryService from "./banner-category";
import BannerTrademarkService from "./banner-trademark";
import HomeSectionsArrangementService from "./arrange-sections-page-home";
import CategoryCharityService from "./category_charity";
import CharityService from "./charity";
import CategoryCampaignService from "./category_campaign";
import BadgeCharityService from "./badge-charity";
import OrphanService from "./orphan";
import AchievementService from "./achievement";
import DonationServiceService from "./donation-service";
import DonationService from "./donation";
import CampaignService from "./campaign";
import BannerAchievementScreenService from "./banner-achievements-screen";
import BannerCampaignsScreenService from "./banner-campaigns-screen";
import BannerOrphanScreenService from "./banner-orphans-screen";
import BannerCharityScreenService from "./banner-charities-screen";
import BannerCharityService from "./banner-charities";
import BannerCampaignService from "./banner-campaigns";
import BeneficiaryGroupsService from "./beneficiary-groups";
import ContactUsService from "./contactus";

export default class EndPoints {
  public static auth = new AuthService(httpclient);
  public static user = new UserService(httpclient);
  public static trademarkManager = new TrademarkManagerService(httpclient);
  public static city = new CityService(httpclient);
  public static role = new RoleService(httpclient);
  public static unit = new UnitsService(httpclient);
  public static tag = new TagsService(httpclient);
  public static unitPartition = new UnitPartitionService(httpclient);
  public static badgeCharity = new BadgeCharityService(httpclient);
  public static orphan = new OrphanService(httpclient);
  public static achievement = new AchievementService(httpclient);
  public static donationService = new DonationServiceService(httpclient);
  public static donation = new DonationService(httpclient);

  public static area = new AreaService(httpclient);
  public static trademark = new TrademarkService(httpclient);
  public static deliveryWorkers = new DeliveryWorkersService(httpclient);
  public static doctor = new DoctorService(httpclient);
  public static category = new CategoryService(httpclient);
  public static categoryCampaign = new CategoryCampaignService(httpclient);
  public static categoryCharity = new CategoryCharityService(httpclient);
  public static charity = new CharityService(httpclient);
  public static campaign = new CampaignService(httpclient);
  public static beneficiaryGroup = new BeneficiaryGroupsService(httpclient);
  public static client = new ClientService(httpclient);
  public static store = new StoreService(httpclient);
  public static storeJoinRequest = new StoreJoinRequestService(httpclient);

  public static investor = new Investorsservice(httpclient);
  public static discountCode = new DiscountCodeService(httpclient);
  public static banner = new BannerService(httpclient);
  public static bannerAchievementScreen = new BannerAchievementScreenService(httpclient);
  public static bannerCampaignsScreenService = new BannerCampaignsScreenService(httpclient);
  public static bannerOrphanScreenService = new BannerOrphanScreenService(httpclient);
  public static bannerCharityScreenService = new BannerCharityScreenService(httpclient);

  public static bannerCategory = new BannerCategoryService(httpclient);
  public static bannerCampaign = new BannerCampaignService(httpclient);
  public static bannerCharity = new BannerCharityService(httpclient);

  public static bannerTrademark = new BannerTrademarkService(httpclient);
  public static attribute = new AttributeService(httpclient);
  public static param = new ParamService(httpclient);
  public static product = new ProductService(httpclient);
  public static commonQuestions = new CommonQuestionservice(httpclient);
  public static chronicDiseases = new ChronicDiseasesService(httpclient);
  public static orderNote = new OrderNoteService(httpclient);
  public static generalSettings = new GeneralSettingervice(httpclient);
  public static policyTerm = new PolicyTermService(httpclient);
  public static homePageList = new HomePageListService(httpclient);
  public static homePageSectionsArrangement = new HomeSectionsArrangementService(httpclient);
  public static generalNotification = new GeneralNotificationService(
    httpclient
  );
  public static complaint = new ComplaintService(httpclient);
  public static statistics = new StatisticsService(httpclient);
  public static statisticsTrademark = new TrademarkStatisticsService(httpclient);
  public static driverTracking = new DriverTrackingService(httpclient);
  public static productStore = new ProductStoreService(httpclient);
  public static order = new OrderService(httpclient);
  public static paymentDeliveryWorker = new PaymentDeliveryWorkersservice(
    httpclient
  );
  public static point = new PointService(httpclient);
  public static paymentPoint = new PaymentPointService(httpclient);
  public static medicalSspecialties = new MedicalSspecialtiesService(
    httpclient
  );
  public static prize = new PrizeService(httpclient);
  public static slice = new SliceService(httpclient);
  public static notification = new NotificationService(httpclient);
  public static media = new MediaService(httpclient);
  public static report = new repotservice(httpclient);
  public static reward = new RewardService(httpclient)
  public static contactUs = new ContactUsService(httpclient)


}
